import { videoTypes } from "./isVideo";

// TODO: in future type of file should be returned from the backend
export const isVideoSrcExtension = (src = ""): boolean => {
    let isVideo = false;

    for (const format of videoTypes) {
        const extension = `.${format.split("/")[1]}`;

        if (src.includes(extension)) {
            isVideo = true;
        }
    }

    return isVideo;
};
